/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Posts_Create_DescriptionInputs */

const en_admin_posts_create_description = /** @type {(inputs: Admin_Posts_Create_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a new blog post`)
};

const zh_admin_posts_create_description = /** @type {(inputs: Admin_Posts_Create_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建一篇新的博客文章`)
};

/**
* | output |
* | --- |
* | "Create a new blog post" |
*
* @param {Admin_Posts_Create_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_posts_create_description = /** @type {((inputs?: Admin_Posts_Create_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Posts_Create_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_posts_create_description(inputs)
	return zh_admin_posts_create_description(inputs)
});
export { admin_posts_create_description as "admin.posts.create_description" }